import { useEffect, memo } from 'react';
import { applyReactStyle } from '../utils/apply-react-style';
import useControl from './use-control';
function AttributionControl(props) {
  var ctrl = useControl(function (_ref) {
    var mapLib = _ref.mapLib;
    return new mapLib.AttributionControl(props);
  }, {
    position: props.position
  });
  useEffect(function () {
    applyReactStyle(ctrl._container, props.style);
  }, [props.style]);
  return null;
}
export default memo(AttributionControl);